import { createEvent } from "ics";
import { intlFormat } from "date-fns";
import { AddToCalendarProps } from "./addToCalendar";

export const addToCalendar = async ({
    title,
    startDate,
    endDate,
    location,
    notes,
}: AddToCalendarProps) => {
    const finalEndDate = endDate ? new Date(endDate) : new Date(startDate);
    const filename = `${title} (${intlFormat(new Date(startDate))} - ${intlFormat(
        finalEndDate,
    )}).ics`;
    const file = await new Promise<Blob>((resolve, reject) => {
        createEvent(
            {
                title,
                description: notes,
                location,
                start: new Date(startDate).getTime(),
                end: finalEndDate.getTime(),
            },
            (error, value) => {
                if (error) {
                    reject(error);
                }

                resolve(new File([value], filename, { type: "text/calendar" }));
            },
        );
    });
    const url = URL.createObjectURL(file);

    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);

    URL.revokeObjectURL(url);
    return "SAVED";
};
